<template>
  <el-dialog class="select-service-modal" title="选择餐厅" :visible.sync="visible" width="1200px">
    <div class="content" v-loading="loading">
      <div class="header"></div>
      <div class="table">
        <div class="table-wrapper">
          <el-table :data="list" stripe style="width: 100%" height="100%">
            <el-table-column prop="index" label="#" align="center" width="60"></el-table-column>
            <el-table-column prop="providerName" label="餐厅名称" align="center" width="120"></el-table-column>
            <el-table-column prop="serviceCategory" label="餐厅类型"></el-table-column>
            <el-table-column prop="address" label="所在区域"></el-table-column>
            <el-table-column prop="shelvesNum" label="菜品数量"></el-table-column>
            <el-table-column label="菜单预览" align="center" width="200">
              <template slot-scope="scope">
                <menu-overview-popper :restaurant-id="scope.row.gid"></menu-overview-popper>
              </template>
            </el-table-column>
            <el-table-column prop="price" label="价格" align="center" width="100"></el-table-column>
            <el-table-column prop="operation" label="操作" fixed="right" width="80">
              <template slot-scope="scope">
                <el-button type="text" @click="select(scope.row)">选择</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <el-pagination
        @size-change="loadData(1, arguments[0])"
        @current-change="loadData(arguments[0])"
        :current-page="pagination.index + 1"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="pagination.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
      ></el-pagination>
    </div>
  </el-dialog>
</template>

<script>
import qs from 'qs'
import _ from 'lodash'
import ModalMixin from '@/libs/modal/modal-mixin'
import MenuOverviewPopper from '@/components/pages/orders/dinner/MenuOverviewPopper'

export default {
  components: { MenuOverviewPopper },
  mixins: [ModalMixin],
  data() {
    return {
      pagination: {
        index: 0,
        total: 0,
        size: 20
      },
      list: [],
      loading: false,
      theOldGid:this.$route.query.oneOldGid || ''
    }
  },
  methods: {
    init(theOldGid) {
      this.theOldGid = theOldGid ? theOldGid : this.theOldGid;
      this.loadData()
      return this.open()
    },
    loadData(index, size) {
      index = index - 1 || 0
      size = size || this.pagination.size
      this.loading = true
      let query = {
        index,
        size,
        type: 2,
        theOldGid:this.theOldGid
      }
      this.Service.call('serviceprovider/bylocation','GET',query).then(data => {
      // this.Service.call('serviceprovider', 'GET', query).then(data => {
        data.data = _.filter(data.data, function(o) { return o.distance < 2000; });
        _.forEach(data.data, (item, idx) => {
          item.index = idx + 1
        })
        this.list = data.data || []
        this.pagination = {
          index: data.index,
          size: data.size,
          total: data.total
        }
      }).finally(() => {
        this.loading = false
      })
    },
    select(row) {
      // // 暂时先判断是否超出配送范围
      // this.Service.call('distance',"POST",qs.stringify({
      //   'theOldGid':this.theOldGid,
      //   'serviceProviderGid':row.gid
      // }),null,null,null,"application/x-www-form-urlencoded").then(res=>{
      //   console.log(res.data);
      //   if(res.avaliable){
      //     this.close(row)
      //   }else{
      //     this.$message.error('超出配送范围，请重新选择商家');
      //   }
        
      // })

      this.close(row)

      
    }
  }
}
</script>
